//https://stackoverflow.com/questions/35274028/stop-event-propagation-in-angular-2

import {Directive, HostListener, Input} from "@angular/core";

@Directive({
    selector: "[click-stop]"
})
export class ClickStopDirective
{
    @Input()
    public readonly disableClickStop: boolean = false;

    @HostListener("click", ["$event"])
    public onClick(event: any): boolean
    {
        if(!this.disableClickStop){
            event.stopPropagation();
            return false;
        }
        return true;
    }
}
